export enum RoutingPages
{
    LANDING             =   "login/:code"     ,
    LANDING_RAW         =   "login/"          ,

    LANDING_OLD         =   "login"           ,
    SSO_CALLBACK        =   "sso/callback"    ,

    MAIN                =   ""                  ,

    ORGANIZATION_DETAIL =   "organizationdetail",
    SITE_DETAIL         =   "sitedetail"        ,
    DASHBOARD           =   "dashboard"         ,
    STATISTIC           =   "statistic"         ,
    TIMESTABLE          =   "tabletime"         ,
    TIMESTABLE_DEVICE   =   "devicetime"        ,
    TIMESTABLE_SERVICE  =   "servicetime"       ,
    SLOTAUTOMATE        =   "slotautomate"      ,
    SLOTMODEL           =   "slotmodel"         ,
    DEVICE_SERVICE      =   "deviceservice"     ,
    OPERATOR            =   "operator"          ,
    OPERATOR_COUNTER    =   "operatorcounter"   ,
    ASSIGN_OPERATOR     =   "operatorassign"    ,
    DEVICE              =   "device"            ,
    MANAGEMENT_MESSAGE  =   "message"           ,
    MANAGEMENT_SERVICE  =   "servicemanagement" ,
    MANAGEMENT_DEVICE   =   "devicemanagement"  ,
    MANAGEMENT_OPERATOR =   "operatormanagement",
    MANAGEMENT_BOOKING  =   "booking"           ,   
    
    MEDIA               =   "media"             ,
    MEDIA_ORGANIZATION  =   "media/organization",   
    MEDIA_SITE          =   "media/site"        ,   
    MEDIA_SERVICE       =   "media/service"     ,   

    SLOT_MODEL          =   "slot/model"        ,   

    LICENCE             =   "licence"

}